import Rollbar from 'rollbar/src/react-native/rollbar';

export default Rollbar;
